import React, { useMemo } from "react";

// ===== helpers =====
const yen = (n) => "¥" + Number(n || 0).toLocaleString("ja-JP");
const fmtDateTime = (ms) => new Date(ms).toLocaleString("ja-JP");

// NEW / badge
const badge = (text, tone = "gray") => {
  const map = {
    gray: { bg: "#f3f4f6", fg: "#374151", bd: "#e5e7eb" },
    amber: { bg: "#fffbeb", fg: "#92400e", bd: "#fde68a" },
    green: { bg: "#ecfdf3", fg: "#027a48", bd: "#abefc6" },
    red: { bg: "#fff1f2", fg: "#9f1239", bd: "#fecdd3" },
    blue: { bg: "#eff6ff", fg: "#1d4ed8", bd: "#bfdbfe" },
  };
  const c = map[tone] || map.gray;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "3px 10px",
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 900,
        border: `1px solid ${c.bd}`,
        background: c.bg,
        color: c.fg,
        whiteSpace: "nowrap",
      }}
    >
      {text}
    </span>
  );
};

const statusTone = (status) => {
  if (status === "未確認") return "red";
  if (status === "受注確定") return "blue";
  if (status === "納品書発行") return "green";
  return "amber";
};

function Th({ children, align = "left" }) {
  return (
    <th
      style={{
        textAlign: align,
        padding: "10px 12px",
        fontSize: 12,
        opacity: 0.7,
        borderBottom: "1px solid #eee",
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </th>
  );
}

function Td({ children, align = "left", style = {} }) {
  return (
    <td
      style={{
        textAlign: align,
        padding: "12px 12px",
        fontSize: 14,
        verticalAlign: "top",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {children}
    </td>
  );
}

export default function WholesaleOrdersPanel({ orders, onOpen }) {
  const sorted = useMemo(() => {
    return [...orders].sort((a, b) => Number(b.createdAt || 0) - Number(a.createdAt || 0));
  }, [orders]);

  return (
    <div style={{ maxWidth: 980 }}>
      <div style={{ display: "flex", alignItems: "baseline", gap: 10, marginBottom: 10 }}>
        <div style={{ fontSize: 18, fontWeight: 900 }}>卸：受注一覧</div>
        <div style={{ opacity: 0.7, fontSize: 12 }}>行クリックで詳細へ（数量変更・受注確定・納品書発行）</div>
      </div>

      <div style={{ border: "1px solid #eee", borderRadius: 12, overflow: "hidden" }}>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 860 }}>
            <thead>
              <tr style={{ background: "#fafafa" }}>
                <Th>注文日時</Th>
                <Th>仕入先</Th>
                <Th align="right">注文点数</Th>
                <Th align="right">合計金額</Th>
                <Th>ステータス</Th>
                <Th>NEW</Th>
                <Th>操作</Th>
              </tr>
            </thead>
            <tbody>
              {sorted.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ padding: 16, textAlign: "center", opacity: 0.7 }}>
                    受注がありません
                  </td>
                </tr>
              ) : (
                sorted.map((o) => {
                  const isNew = !o.seenByWholesale || o.status === "未確認";
                  const itemCount = (o.lines || []).reduce((sum, l) => sum + Number(l.qty || 0), 0);

                  return (
                    <tr
                      key={o.id}
                      onClick={() => onOpen?.(o.id)}
                      style={{
                        cursor: "pointer",
                        borderTop: "1px solid #eee",
                        background: isNew ? "rgba(255, 237, 213, 0.55)" : "transparent",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = isNew ? "rgba(255, 237, 213, 0.75)" : "#fcfcfc")}
                      onMouseLeave={(e) => (e.currentTarget.style.background = isNew ? "rgba(255, 237, 213, 0.55)" : "transparent")}
                    >
                      <Td>{fmtDateTime(o.createdAt)}</Td>
                      <Td style={{ fontWeight: 900 }}>{o.supplierName || "-"}</Td>
                      <Td align="right" style={{ fontWeight: 900 }}>
                        {itemCount}
                      </Td>
                      <Td align="right" style={{ fontWeight: 900 }}>
                        {yen(o.total)}
                      </Td>
                      <Td>{badge(o.status || "-", statusTone(o.status))}</Td>
                      <Td>{isNew ? badge("NEW", "amber") : <span style={{ opacity: 0.4 }}>—</span>}</Td>
                      <Td>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onOpen?.(o.id);
                          }}
                          style={{
                            padding: "8px 10px",
                            borderRadius: 10,
                            border: "1px solid #111",
                            fontWeight: 900,
                            background: "#111",
                            color: "white",
                            cursor: "pointer",
                          }}
                        >
                          詳細へ
                        </button>
                      </Td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
